import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { MembershipProvider } from './contexts/MembershipContext';
import Header from './components/Header';
import ConditionalLandingPage from './pages/ConditionalLandingPage';
import InterviewPage from './pages/InterviewPage';
import FinishedInterviewPage from './pages/FinishedInterviewPage';
import InterviewResultPage from './pages/InterviewResultPage';
import PricingPage from './pages/PricingPage';
import LoginPage from './pages/LoginPage';
import SignUpPage from './pages/SignUpPage';
import ProfilePage from './pages/ProfilePage';
import SubscriptionPage from './pages/SubscriptionPage';
import PracticePage from './pages/PracticePage';
import SubscriptionSuccessPage from './pages/SubscriptionSuccessPage';
import SubscriptionCancelPage from './pages/SubscriptionCancelPage';
import RedirectToHome from './components/RedirectToHome';

function App() {
  return (
    <AuthProvider>
      <MembershipProvider>
        <Router>
          <div className='h-screen bg-gray-100 flex flex-col'>
            <Header />
            <div className='flex-1'>
              <Routes>
                <Route
                  path='/'
                  element={<ConditionalLandingPage />}
                />
                <Route
                  path='/practice/coding_interview'
                  element={<InterviewPage />}
                />
                <Route
                  path='/practice/finished'
                  element={<FinishedInterviewPage />}
                />
                <Route
                  path='/practice/result/:resultId'
                  element={<InterviewResultPage />}
                />
                <Route
                  path='/pricing'
                  element={<PricingPage />}
                />
                <Route
                  path='/login'
                  element={<LoginPage />}
                />
                <Route
                  path='/signup'
                  element={<SignUpPage />}
                />
                <Route
                  path='/profile'
                  element={<ProfilePage />}
                />
                <Route
                  path='/profile/subscription'
                  element={<SubscriptionPage />}
                />
                <Route
                  path='/practice'
                  element={<PracticePage />}
                />
                <Route
                  path='/subscription/success'
                  element={<SubscriptionSuccessPage />}
                />
                <Route
                  path='/subscription/cancel'
                  element={<SubscriptionCancelPage />}
                />
                {/* Wildcard route - catch all undefined paths and redirect to home */}
                <Route
                  path='*'
                  element={<RedirectToHome />}
                />
              </Routes>
            </div>
          </div>
        </Router>
      </MembershipProvider>
    </AuthProvider>
  );
}

export default App;
